"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _MessageBoxComponent.default;
  }
});

var _MessageBoxComponent = _interopRequireDefault(require("./MessageBox-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }